<ub-card [rounded]="true" [dividers]="false">
  <div content class="user-view">
    <div class="user-view__overview">
      <div class="user-view__overview__profile">
        <ub-avatar name="{{ user.fullname }}"></ub-avatar>
        <div class="user-view__overview__information">
          <h1>{{ user.fullname }}</h1>
          <ub-label variant="primary" text="{{ user.stateName }}"></ub-label>
          <eas-roles-title [roles]="roles"></eas-roles-title>
          <p *ngIf="user.doc.state === 'disabled'" i18n>User has been disabled with this reason: {{ disabledReason }}
          </p>
        </div>
      </div>
      <div class="user-view__overview__actions">
        <ub-button-list>
          <ng-container *ngFor="let item of (buttons$ | async)">
            <a color="accent" mat-flat-button *ngIf="item.type === 'link'" [routerLink]="item.link | async">
              {{ item.label }}
            </a>
            <button mat-flat-button *ngIf="item.type === 'button'" color="warn"
              (click)="item.click()">{{ item.label }}</button>
          </ng-container>
        </ub-button-list>
      </div>
    </div>

    <div class="user-view__login">
      <div class="user-view__box">
        <eas-user-login [accountId]="user.doc.user"></eas-user-login>
      </div>
      <div *ngIf="canUserSetLanguage()" class="user-view__box">
        <eas-user-language></eas-user-language>
      </div>
      <div class="user-view__box">
        <eas-auditlog [dates]="user.dates"></eas-auditlog>
      </div>
    </div>

    <div class="user-view__details">
      <app-form-default [formData$]="formData$"></app-form-default>
      <eas-user-emails [primaryEmail]="user.email" [secondaryEmails]="user.secondaryEmails"></eas-user-emails>
    </div>
    <div class="user-view__history">
      <eas-user-history [history]="history"></eas-user-history>
    </div>
  </div>
</ub-card>
